export const BQ_EVENTS = {
    HOVERED_ON_CLIENT: 'hovered_on_client_notable_clients',
    CLICKED_ON_CLIENT: 'clicked_on_clients_notable_clients',
    SHOWN_NOTABLE_CLIENTS_ABOVE_FOLD: 'notable_clients_above_fold_is_shown',
    SELLER_CLICKED_ON_ADD_CLIENT: 'seller_clicked_on_add_a_client',
    HIDDEN: 'notable_clients_is_hidden',
    HOVERED_ON_RISING_BADGE: 'hovered_on_rising_talent_badge',
    VERIFIED_HOVERED_ON_BADGE: 'hovered_on_verified_seller_sign',
    VERIFIED_EDUCATION_POP_UP_SHOWN: 'educational_tool_verified_seller_pop_up_is_shown',
    VERIFIED_CLICKED_ON_GOT_IT_EDUCATIONAL: 'clicked_on_got_it_on_educational_tool_verified_seller_pop_up',
    VERIFIED_ABOVE_SIGN_IS_SHOWN: 'verified_seller_sign_above_fold_is_shown',
    VERIFIED_BELOW_SIGN_IS_SHOWN: 'verified_seller_sign_below_fold_is_shown',
    CLICKED_ON_CREATE_AGENCY: 'agency_clicked_on_create_agency',
    CLICKED_ON_MANAGE_AGENCY: 'agency_clicked_on_manage_agency',
    CLICKED_ON_EDIT_AGENCY: 'agency_clicked_on_edit_agency_page',
    AGENCY_CREATE_OR_MANAGE_BUTTON_IS_SHOWN: 'agency_create_or_manage_button_is_shown',
    MANAGE_VIDEO_MEETING_IS_SHOWN: 'manage_video_meeting_is_shown',
    CLICKED_ON_MANAGE_VIDEO_MEETING: 'clicked_on_manage_video_meeting',
    SELLER_HOURLY_RATE_SETUP_IS_SHOWN: 'seller_hourly_rate_is_shown',
    CLICKED_ON_SELLER_HOURLY_RATE: 'clicked_on_seller_hourly_rate'
};

export const BI_CONSTS = {
    DOMAIN: 'sellers',
    SUB_DOMAIN: 'pumas',
    CLIENT_ENTITY: 'client',
    GROUPS: {
        ACTIONS: 'user_actions',
        IMPRESSIONS: 'user_impressions'
    },
    SUB_GROUPS: {
        RISING_TALENT: 'rising_talent',
        NOTABLE_CLIENTS: 'notable_clients',
        VERIFIED_BADGE: 'verified_badge'
    },
    CLICK_ACTION_TYPE: 'click'
};

export const SOURCES = {
    SELF_VIEW: 'self_view_page',
    CHECKOUT: 'checkout_page',
    SELLER: 'seller_page',
    GIG: 'gig_page',
    LISTINGS: 'listing_page',
    BELOW_THE_FOLD: 'below the fold',
    ABOVE_THE_FOLD: 'above the fold',
    UNKNOWN: 'unknown'
};

export const MIXPANEL_FIELD_NAMES = {
    USER_ID: 'User ID',
    USER_GUID: 'User GUID',
    SELLER_NAME:'Seller Name',
    SELLER_ID: 'Seller Id',
    CLIENT_NAME: 'Client Name',
    CLIENT_NAMES: 'Clients Names',
    CLIENTS_COUNT: 'Number of clients',
    ORIGIN: 'Source page'
};

export const MIXPANEL_EVENT_VARIATION = {
    VIEW: 'view',
    INTERACTION: 'interaction',
    DELIMITER: ':'
};

const { DELIMITER } = MIXPANEL_EVENT_VARIATION;

export const MP_EVENTS = {
    SELLER_PAGE_CLIENTS_INTERACTION: `${SOURCES.SELLER}${DELIMITER}${MIXPANEL_EVENT_VARIATION.INTERACTION}`,
    CHECKOUT_PAGE_CLIENTS_VIEWED: `${SOURCES.CHECKOUT}${DELIMITER}${MIXPANEL_EVENT_VARIATION.VIEW}`,
    CHECKOUT_PAGE_CLIENTS_INTERACTION: `${SOURCES.CHECKOUT}${DELIMITER}${MIXPANEL_EVENT_VARIATION.INTERACTION}`,
    LISTING_PAGE_CLIENTS_VIEWED: `${SOURCES.LISTINGS}${DELIMITER}${MIXPANEL_EVENT_VARIATION.VIEW}`,
    LISTING_PAGE_CLIENTS_INTERACTION: `${SOURCES.LISTINGS}${DELIMITER}${MIXPANEL_EVENT_VARIATION.INTERACTION}`,
    UNKNOWN_PAGE_CLIENTS_VIEW: `${SOURCES.UNKNOWN}${DELIMITER}${MIXPANEL_EVENT_VARIATION.VIEW}`,
    UNKNOWN_PAGE_CLIENTS_INTERACTION: `${SOURCES.UNKNOWN}${DELIMITER}${MIXPANEL_EVENT_VARIATION.INTERACTION}`,
    GIG_PAGE_VERIFIED_TOP_VIEWED: `${SOURCES.GIG}${DELIMITER}${SOURCES.ABOVE_THE_FOLD}${DELIMITER}${MIXPANEL_EVENT_VARIATION.VIEW}`,
    GIG_PAGE_VERIFIED_TOP_INTERACTION: `${SOURCES.GIG}${DELIMITER}${SOURCES.ABOVE_THE_FOLD}${DELIMITER}${MIXPANEL_EVENT_VARIATION.INTERACTION}`,
    GIG_PAGE_VERIFIED_BOTTOM_VIEWED: `${SOURCES.GIG}${DELIMITER}${SOURCES.BELOW_THE_FOLD}${DELIMITER}${MIXPANEL_EVENT_VARIATION.VIEW}`,
    GIG_PAGE_VERIFIED_BOTTOM_INTERACTION: `${SOURCES.GIG}${DELIMITER}${SOURCES.BELOW_THE_FOLD}${DELIMITER}${MIXPANEL_EVENT_VARIATION.INTERACTION}`,
    SELLER_PAGE_VERIFIED_TOP_VIEWED: `${SOURCES.SELLER}${DELIMITER}${SOURCES.ABOVE_THE_FOLD}${DELIMITER}${MIXPANEL_EVENT_VARIATION.VIEW}`,
    SELLER_PAGE_VERIFIED_TOP_INTERACTION: `${SOURCES.SELLER}${DELIMITER}${SOURCES.ABOVE_THE_FOLD}${DELIMITER}${MIXPANEL_EVENT_VARIATION.INTERACTION}`,
    SELLER_PAGE_VERIFIED_BOTTOM_VIEWED: `${SOURCES.SELLER}${DELIMITER}${SOURCES.BELOW_THE_FOLD}${DELIMITER}${MIXPANEL_EVENT_VARIATION.VIEW}`,
    SELLER_PAGE_VERIFIED_BOTTOM_INTERACTION: `${SOURCES.SELLER}${DELIMITER}${SOURCES.BELOW_THE_FOLD}${DELIMITER}${MIXPANEL_EVENT_VARIATION.INTERACTION}`,
    SELFVIEW_IMPRESSION: 'Profile Edit Top Client View',
    SELFVIEW_ADD_CLIENT: 'Profile Edit Top Client Add clicked',
    SELFVIEW_EDIT_CLIENT: 'Profile Edit Top Client Edit clicked',
    SELFVIEW_DELETE_CLIENT: 'Profile Edit Top Client Delete clicked',
    INTRO_SELFVIEW_IMPRESSION: 'Profile Edit Intro Video Impression',
    INTRO_SELFVIEW_ADD: 'Profile Edit Intro Video Add clicked',
    INTRO_SELFVIEW_EDIT: 'Profile Edit Intro Video Edit clicked',
    INTRO_SELFVIEW_DELETE: 'Profile Edit Intro Video Delete clicked',
    INTRO_SELFVIEW_VIDEO_VIEW: 'Profile Edit Intro Video View',
    CONSULTATION_SETTINGS_SELFVIEW_IMPRESSION: 'Profile Edit Consultation Settings View',
    CONSULTATION_SETTINGS_SELFVIEW_CTA_CLICK: 'Profile Edit Consultation Settings CTA Click',
    VIDEO_MEETINGS_SELFVIEW_IMPRESSION: 'Profile Edit Video Meetings View',
    VIDEO_MEETINGS_SETTINGS_SELFVIEW_CTA_CLICK: 'Profile Edit Video Meetings CTA Click'
};
